import { PRE_GREETING_ROUTING } from './pre-greeting-routing.js';
import { PROPERTY_MATCH } from './property-match.js';
export const DECISION_DEFINITIONS = {
    [PRE_GREETING_ROUTING]: {
        displayName: 'Pre-greeting routing',
        highlights: {
            primary: ['outcome.chosenScenarioId', 'reason'],
            secondary: ['outcome.matchedScenarioIds', 'outcome.resolvedAgentId'],
        },
    },
    [PROPERTY_MATCH]: {
        displayName: 'Property match',
        highlights: {
            primary: ['reason', 'outcome.chosen.street'],
            secondary: ['inputs.query', 'outcome.isAmbiguous'],
        },
    },
};
//# sourceMappingURL=registry.js.map